import {gsap, TimelineLite} from "gsap";
import {useLocation} from "react-router-dom";
import React, {useEffect, useLayoutEffect, useRef} from 'react';
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {DrawSVGPlugin} from "gsap/dist/DrawSVGPlugin";
import {useDispatch, useSelector} from "react-redux";
import {loading} from "../../api/redux/global";

const PageTransition = () => {

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);
    const location = useLocation();
    let MainStore = useSelector(state => state)
    const dispatch = useDispatch()


    // preloader start on page/router change
    useEffect(() => {
        const tl = new TimelineLite()

        dispatch(loading())
        tl.to('.page-loader', {
            opacity: 1,
            duration: 0.4,
            ease: 'Cubic.easeOut',
            display: 'flex'
        }).to('.page-loader img', {
            duration: .3,
            opacity: 1
        }, '-=.7').fromTo('.page-loader svg line', {
            drawSVG: "0%",
        }, {
            // delay: .02,
            duration: 3,
            drawSVG: "100%",
            ease: 'Cubic.easeOut',
            stagger: .02
        })
    }, [location.pathname])

    // preloader end after page load
    useEffect(() => {
        const tl = new TimelineLite()
        if (!MainStore.globalReducer.globalLoader) {
            tl.to('.page-loader', {
                delay: 1,
                opacity: 0,
                duration: .8,
                display: 'none'
            }).to('.page-loader svg line', {
                duration: 0,
                drawSVG: "0%",
            })
        }
    }, [MainStore])

};

export default PageTransition;
